import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { ThreadCoachPage } from '~/features/coach/coach-page';

function ThreadRoute(): ReactElement {
  const { threadId } = Route.useParams();
  return <ThreadCoachPage threadId={threadId} />;
}

/** One conversation, open or reopened from the server (board 11-coach-thread). */
export const Route = createFileRoute('/_app/coach/$threadId')({ component: ThreadRoute });
